import type {FixButtonVariant} from '@Components/social-media/components/fix-this-button';

export const PLAN_LOCKED_UPGRADE_ICON = 'icon-crown';

export interface PlanLockedUpgradeButtonProps {
  variant?: FixButtonVariant;
  isFullWidth?: boolean;
  customClasses?: string;
}
